import React, { useRef, useEffect } from "react";

const TextInput = ({
  id,
  label,
  value,
  onChange,
  disabled = false,
  invalid = false,
  required = false,
}) => {
  const textareaRef = useRef(null);

  // Resize whenever the value changes
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto"; // reset
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [value]);

  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-4 w-full mb-4">
      <label
        htmlFor={id}
        className="text-base font-medium text-black whitespace-nowrap"
      >
        {label}
        {required && " *"}
      </label>
      <textarea
        ref={textareaRef}
        id={id}
        disabled={disabled}
        value={value}
        onChange={onChange}
        className={`${disabled ? "!text-black !opacity-100" : ""} w-full sm:flex-1 px-0 py-2 border-0 border-b-2 ${
          invalid ? "border-b-red-500" : "border-b-gray-300"
        } overflow-hidden focus:outline-none focus:ring-0 focus:border-b-indigo-500 bg-slate-50 font-medium resize-none`}
      />
    </div>
  );
};

export default TextInput;
